<template>
  <div>
    <!-- Display 404 error page if statusCode is '404' -->
    <div v-if="statusCode === '404'">
      <h3 class="mx-2" style="font-size: 22px; color: #B1B1B1;">404 Error</h3>
      <div class="overallsec">
        <img :src="imagePath" alt="Error Image" />
        <div class="d-flex">
          <div class="box1"> <span class="mx-2"></span><span class="mx-2"></span><span class="mx-2"></span></div>
          <div class="box2"> <span class="mx-2"></span><span class="mx-2"></span><span class="mx-2"></span></div>
        </div>
        <p>Oops!, Data Not Found.</p><br><span class="text">Maybe check the URL again?</span>
      </div>
    </div>

    <!-- Display 401 error page if statusCode is '401' -->
    <div v-if="statusCode === '401'">
      <h3 class="mx-2" style="font-size: 22px; color: #B1B1B1;">401 Error</h3>
      <div class="overallsec">
        <img :src="imagePath1" alt="Error Image" />
        <div class="d-flex">
          <div class="box1"> <span class="mx-2"></span><span class="mx-2"></span><span class="mx-2"></span></div>
          <div class="box2"> <span class="mx-2"></span><span class="mx-2"></span><span class="mx-2"></span></div>
        </div>
        <p>Oops!, Unauthorized Access.</p><br><span class="text">Maybe check the URL again?</span>
      </div>
    </div>

    <!-- Display 403 error page if statusCode is '403' -->
    <div v-if="statusCode === '403'">
      <h3 class="mx-2" style="font-size: 22px; color: #B1B1B1;">403 Error</h3>
      <div class="overallsec">
        <img :src="imagePath2" alt="Error Image" />
        <div class="d-flex">
          <div class="box1"> <span class="mx-2"></span><span class="mx-2"></span><span class="mx-2"></span></div>
          <div class="box2"> <span class="mx-2"></span><span class="mx-2"></span><span class="mx-2"></span></div>
        </div>
        <p>Oops!, Forbidden Access.</p><br><span class="text">Maybe check the URL again?</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      statusCode: null, 
      imagePath: require('@/assets/404.png'),  
      imagePath1: require('@/assets/401.png'),
      imagePath2: require('@/assets/403.png'),
    };
  },
  created() {
    this.statusCode = this.$route.query.statusCode; 
  },
};
</script>

<style scoped>
.overallsec {
  position: relative;
  left: 500px;
  top: 130px;
}

p {
  margin-bottom: -15px;
  font-size: 20px;
  color: #B1B1B1;
  margin-left: 21px;
}

.text {
  margin-right: 10px;
  font-size: 20px;
  color: #B1B1B1;
}

.box1 {
  position: relative;
  left: -99px;
  top: -8px;
}

.box2 {
  position: relative;
  right: 370px;
  top: -8px;
}

.box1 span,
.box2 span {
  border: none;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #D9D9D9;
  display: inline-flex;
  justify-content: space-around;
}
</style>
